import React from 'react'
import {find} from 'lodash'

import {replaceExpression} from '../utils'
import PrintCount from './PrintCount'
import PrintExplanationText from './PrintExplanationText'

export default class PrintRadioQuestionExplanation extends React.Component {
  constructor(props, context) {
    super(props, context)
    this.state = {showTextBox: false, consult: false}
  }

  getValue(optionId) {
    const value = find(this.props.state, s => s.optionId === optionId)
    return value ? value.booleanValue : false
  }

  getOriginalValue(optionId) {
    let value = undefined

    if (this.props.originalState) {
      value = find(this.props.originalState, s => s.optionId === optionId)
    }
    return value ? value.booleanValue : false
  }

  render() {
    const {data, answermap, collaborationresponse} = this.props
    const tableStyle = {
      fontSize: 10 + 'px'
    }

    return (
      <div className="question-group type-radio">
        <p style={{fontSize: '15px', lineHeight: '1.3em'}}>{replaceExpression(data.questionText, answermap)}</p>
        <div style={{fontSize: '11px', fontStyle: 'italic', lineHeight: '1.4em'}}
             dangerouslySetInnerHTML={{__html: replaceExpression(data.explanation, answermap)}}></div>

        <table style={tableStyle} width="100%">
          <tbody>
            <tr>
              <td width="55%"><span>&nbsp;</span></td>
              <td width="45%">Ingevuld</td>
            </tr>
            {data.options.map((option, i) => (
              <tr key={i + option.id}>
                <td>
                  <div className="text">{replaceExpression(option.optionText, answermap)}</div>
                </td>
                <td>
                  <PrintCount option={option}
                              collaborationresponse={collaborationresponse}/>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <table style={tableStyle} width="100%">
          <tbody>
            <tr>
              <td width="55%"><span>Toelichting</span></td>
              <td width="45%"><span>&nbsp;</span></td>
            </tr>
            {data.options.filter(option => {return option.optionText === undefined || option.optionText === ''})
                         .map((option, i) => {
                          return (
                            <PrintExplanationText key={i + option.id}
                                                  option={option}
                                                  collaborationresponse={collaborationresponse}/>
                          )
                        }
            )}
          </tbody>
        </table>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/PrintRadioQuestionExplanation.js